import React, { useEffect, useState } from 'react';

import { ADMIN_ROLE, EDITOR_ROLE, SUBMITTER_ROLE, SUBMITTED_FOR_REVIEW, PUBLISHED } from '../../ModulePage/exportfiles';
import './RenderButton.scss';

const RenderButton = ({isSaving, isSubmitting, saveAction, submitAction, org_rol_s, unsubmitAction, readOnly, status, onPublish, enable}) => {

  //These states are used to activate the dot animation
  const [saveProgress, setSaveProgress] = useState(isSaving);
  const [submitProgress, setSubmitProgress] = useState(isSubmitting);
  
  //Adds a 1 second delay to show dots animation to prevent users from clicking the save or submit button while in progress
  useEffect(() => {
    if (saveProgress) {
      const timer = setTimeout(() => {
        setSaveProgress(false);
      }, 500);
      return () => clearTimeout(timer); // Clean up the timer on component unmount or dependency change
    }
  }, [setSaveProgress, saveProgress]);

  useEffect(() => {
    if (submitProgress) {
      const timer = setTimeout(() => {
        setSubmitProgress(false);
      }, 500);
      return () => clearTimeout(timer); // Clean up the timer on component unmount or dependency change
    }
  }, [submitProgress, setSubmitProgress]);

  //This function is based of the function found in ModulePage.js
  //Determines submit status based on Role number (found in state) and readOnly state
  const RenderSubmitButton = ({ action, unsubmitAction, roleNumber, status, onPublish }) => {
    switch (roleNumber) {
      case ADMIN_ROLE:{
       
           if(status.toUpperCase() === SUBMITTED_FOR_REVIEW)
           {
            return (<>
            <button type='button' className={`cb-btn cb-btn-primary`} 
            onClick={() => { setSubmitProgress(!submitProgress); unsubmitAction(); }} id='btn_unsubmit' 
            style={{ marginLeft: '10px' }} data-testid='submitBtn'
            >Unsubmit</button>

            <button style={{backgroundColor:'white', color:'black', marginLeft:'5px'}} 
            data-testid='publishBtn'  id='btn_edit_publish' type='button' 
            className='cb-btn cb-btn-primary' 
            onClick={onPublish}>Accept</button>
            </>);
           }
           else if(status.toUpperCase() === PUBLISHED){
            return (
            <>
            <button type='button' className={`cb-btn cb-btn-primary`} onClick={() => { setSubmitProgress(!submitProgress); unsubmitAction(); }} 
            id='btn_unsubmit' style={{ marginLeft: '10px' }}
            data-testid='submitBtn'>Unsubmit</button>

            <button style={{backgroundColor:'white', color:'black', marginLeft:'5px'}} disabled data-testid='publishBtn' id='btn_publish' type='button' className='cb-btn cb-btn-primary'  onClick={onPublish}>Accept</button>
            </>);
           }
           else{
            return (<>
            <button type='button' className={`cb-btn cb-btn-primary`} onClick={() => { setSubmitProgress(!submitProgress); action(); }} id='btn_submit' style={{ marginLeft: '10px' }} data-testid='submitBtn'>Submit</button>
            <button style={{backgroundColor:'white', color:'black', marginLeft:'5px'}} disabled data-testid='publishBtn' type='button' id='btn_publish' className='cb-btn cb-btn-primary'  onClick={onPublish}>Accept</button>
            </>);}
          }

      case SUBMITTER_ROLE:
        return (
          <>
            {/* If a Submitter then submit is available only if its not read-only*/}
            <button type='button' className={`cb-btn cb-btn-primary`} onClick={() => { setSubmitProgress(!submitProgress); action();}} 
            disabled={readOnly} 
            id='btn_submit' style={{marginLeft: '10px'}} 
            data-testid='submitBtn'>Submit for Review</button>
          </>
        );
      case EDITOR_ROLE:
        return (<></>);
      default:
        return (<></>);
    }
  };
  //Pulse dots button animation
  const PulseDots = (style) => {
    return (
      <button className={`cb-btn cb-btn-${style} cb-btn-pulse`} type='button'>
        Primary
        <div className='cb-btn-pulse-dots'>
          <div className='cb-btn-dots' />
        </div>
      </button>
    );
  };
  
  return (
    <span className='buttonflex' style={{display:`${enable?'inline-flex':'none'}`}}>
      <span>
    {!saveProgress ? (
      <button type='button' className={`cb-btn cb-btn-secondary`}
        disabled={readOnly}
        onClick={ ()=>{ setSaveProgress(!saveProgress); saveAction();}}
        //style={{display: `${readOnly ? 'none' : 'inline-flex'}`}}
        id='btn_save'
        data-testid='saveBtn'
      >
        Save
      </button>) :
      (
        <PulseDots style={'secondary'}/>
      )}
      </span>
      <span>
        {!submitProgress 
          ? (<RenderSubmitButton action={submitAction} unsubmitAction={unsubmitAction} roleNumber={org_rol_s} readOnly={readOnly} status={status} onPublish={onPublish}/>)
          : (<PulseDots style={'primary'} />)}
      </span>
    </span>
);};
export default RenderButton;